import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import DiscoverySectionItem from "./DiscoverySectionItem";
import {useNavigate} from "react-router-dom";
import { UseGetAllActiveMealAds } from "../../../../../api/useMeal";
import {RootState} from "../../../../../reducers/store";
import { useTranslation } from "react-i18next";

const DiscoverySectionItemList = () => {
    const { t } = useTranslation();
    
    const isAuthStore = useSelector((state: RootState) => state.user.isAuth);
    const dispatch = useDispatch();
    const [data, setData] = useState<any[]>();
    const [categoriesMap, setCategoriesMap] = useState<Map<string, any[]>>(new Map());
    const [singleItemCategoriesMap, setSingleItemCategoriesMap] = useState<Map<string, any[]>>(new Map());
    const userIdStore = useSelector((state: RootState) => state.user.id);
    
    const [width, setWidth] = useState(window.innerWidth);
    
    //const itemsPerPage = width > 767 ? 3 : 4;
    const [visibleItems, setVisibleItems] = useState<number>(width > 767 ? 3 : 4);
    const navigate = useNavigate();

    const handleShowMore = (category: string) => () => {
        navigate(`/food/${category}`);
    }
    
    const updateDimensions = () => {
        setWidth(window.innerWidth);
        if (window.innerWidth > 767) {
            setVisibleItems(3);
        } else {
            setVisibleItems(4);
        }
    }
    useEffect(() => {
        window.addEventListener("resize", updateDimensions);
        return () => window.removeEventListener("resize", updateDimensions);
    }, []);
    
    
    const handleShowItemDetails = (category: string, item: any) => () => {
        console.log("item: ", item);
        localStorage.setItem("selectedOrder", JSON.stringify(item));
        navigate(`/food/${category.toLowerCase()}/${item.data._id}`);
    }
    
    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await UseGetAllActiveMealAds(userIdStore || null);
                console.log("UseGetAllMealAds response: ", response);
                if (response && response.status === 200) {
                    const fetchedData = response.result;
                    const categoriesMap = new Map<string, any[]>();
                    const singleCategoriesMap = new Map<string, any>();
                    const uniqueIds = new Set<string>();
                    
                    fetchedData?.forEach((item: any) => {
                        item.category.forEach((category: string) => {
                            const normalizedCategory = category.toLowerCase();
                            if (!categoriesMap.has(normalizedCategory)) {
                                categoriesMap.set(normalizedCategory, []);
                            }
                            categoriesMap.get(normalizedCategory)!.push(item);
                        });
                    });
                    
                    //Array.from(categoriesMap.entries()).forEach(([category, items]) => {
                    //    if (items.length === 1) {
                    //        singleCategoriesMap.set(category, items[0]);
                    //        categoriesMap.delete(category);
                    //    }
                    //});
                    
                    Array.from(categoriesMap.entries()).forEach(([category, items]) => {
                        if (items.length === 1) {
                            const item = items[0];

                            if (!uniqueIds.has(item.data._id)) {
                                singleCategoriesMap.set(category, item);
                                uniqueIds.add(item.data._id);
                            }
                            categoriesMap.delete(category);
                        }
                    });
                    
                    console.log("categoriesMap: ", categoriesMap);
                    console.log("singleCategoriesMap: ", singleCategoriesMap);
                    
                    setCategoriesMap(categoriesMap);
                    setSingleItemCategoriesMap(singleCategoriesMap);
                }
            } catch (error) {
                console.log(error);
            } finally {
                window.scrollTo({ top: 0, behavior: 'smooth' });
            }
        };
        
        fetchData().then(r => console.log("r: ", r));
    }, [dispatch]);
    
    return (
      <div className="discoverySectionItemList__container">
          <div className="discoverySectionItemList__container-wrap">
              {Array.from(categoriesMap.keys()).map((category, indx) => (
                <div className="discoverySectionItemList__container-wrap-map" key={indx}>
                    
                      <div className="discoverySectionItemList__container-title-wrap">
                          <div className="discoverySectionItemList__container-title-text">
                              <span>{category}</span>
                          </div>
                      </div>
                    <div className="discoverySectionItemList__container-items-wrap">
                        {categoriesMap.get(category)
                                       ?.slice(0, visibleItems)
                                       .map((item, itemIndex) => (
                                         <div
                                           className="discoverySectionItemList__container-item-element"
                                           key={itemIndex}
                                           onClick={handleShowItemDetails(category.toLowerCase().replace(/\s/g, "-"), item)}
                                         >
                                             <DiscoverySectionItem
                                               isDineIn={item.isDineIn}
                                               image={item.data.image}
                                               name={item.data.name}
                                               priceBefore={item.data.priceBefore}
                                               priceNow={item.data.priceNow}
                                               discount={item.data.discount}
                                               address={item.data?.restaurantId?.address?.name}
                                               onOption={item.data?.onOption}
                                             />
                                         </div>
                                       ))}
                    </div>
                    
                    {categoriesMap.get(category) && categoriesMap.get(category)!.length > visibleItems && (
                      <div
                        className="discoverySectionItemList__container-items-more-wrap"
                        onClick={() => setVisibleItems(prev => prev + 3)}
                      >
                          <div className="discoverySectionItemList__container-items-more-text">
                              <span>{t('buttons.seeMore')} {category}</span>
                          </div>
                          <div className="discoverySectionItemList__container-items-more-icon">
                              <img
                                src={`${process.env.PUBLIC_URL}/images/show-more-icon.svg`}
                                alt="show more icon"
                              />
                          </div>
                      </div>
                    )}
                </div>
              ))}
          </div>
          
          <div className="discoverySectionItemList__single-items-container">
              {Array.from(singleItemCategoriesMap.entries()).map(([category, item]: any, indx) => (
                <div className="discoverySectionItemList__single-item-wrap" key={indx}>
                    <div className="discoverySectionItemList__container-title-wrap">
                        <div className="discoverySectionItemList__container-title-text">
                            <span>{category}</span>
                        </div>
                    </div>
                    <div
                      className="discoverySectionItemList__container-item-element"
                      onClick={handleShowItemDetails(category.toLowerCase().replace(/\s/g, "-"), item)}
                    >
                        <DiscoverySectionItem
                          isDineIn={item.isDineIn}
                          image={item.data.image}
                          name={item.data.name}
                          priceBefore={item.data.priceBefore}
                          priceNow={item.data.priceNow}
                          discount={item.data.discount}
                          address={item.data?.restaurantId?.address?.name}
                          onOption={item.data?.onOption}
                        />
                    </div>
                </div>
              ))}
          </div>
      </div>
    );
};

export default DiscoverySectionItemList;